module.exports = __webpack_public_path__ + "static/assets/37e2dcf19a0523d42aa4e5f055a2f5cf.svg";